import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import navLogo from "../assets/snapedit_1730103350830.png";

import reoder from "../assets/reorder-svgrepo-com.svg";

import styled from "styled-components";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";

// Styled components

const IconItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0 15px;

  transition: transform 0.3s ease; /* Transition for scaling */

  &:hover {
    transform: scale(1.1); /* Scale effect on hover */
  }
`;

const Icon = styled.div`
  margin-right: 5px;
  font-size: 20px;
  transition: color 0.3s ease, transform 0.3s ease; /* Transition for color and scaling */

  ${IconItem}:hover & {
    cursor: pointer;
    color: #007bff; /* Change color on hover */
    transform: scale(1.2); /* Slightly increase size of the icon on hover */
  }
`;

function Navbar() {
  const [expandNavbar, setExpandNavbar] = React.useState(false);

  const location = useLocation();

  useEffect(() => {
    setExpandNavbar(false);
  }, [location]);

  return (
    <div className="nav-container">
      <footer className="nav-footer">
        <div className="icon-container">
          <div className="icon">
            <Icon as={FaPhone} />
            <span>+27 768 486145</span>
          </div>
          <div className="icon">
            <Icon as={FaEnvelope} />
            <span>giftengptyltd@gmail.com</span>
          </div>
          <div href="" className="icon">
            <Icon as={FaMapMarkerAlt} />
            <span> 48 Oliver Tambo Lotus Gardens 0008 Pretoria</span>
          </div>
          <IconItem>
            <a
              href="https://www.facebook.com/share/HXinVBXZcniiW4FP/?mibextid=LQQJ4d"
              className="social-link"
            >
              <Icon as={FaFacebook} />
            </a>
          </IconItem>
          <IconItem>
            <a
              href="https://www.linkedin.com/company/gifteng-aerial-solutions"
              className="social-link"
            >
              <Icon as={FaLinkedin} />
            </a>
          </IconItem>
          <IconItem>
            <a
              href="https://www.instagram.com/gifteng_aerial_solutions/profilecard/?igsh=MXViMTN3d3NsMHFiOA=="
              className="social-link"
            >
              <Icon as={FaInstagram} />
            </a>
          </IconItem>
        </div>
      </footer>
      <nav className="navbar" id={expandNavbar ? "open" : "close"}>
        <Link to="/" className="logo">
          <img src={navLogo} alt="nav-logo" className="nav-logo" />
        </Link>
        <div className="links">
          <Link to="/" className="nav-item">
            HOME
          </Link>
          <Link to="/about-us" className="nav-item">
            ABOUT US
          </Link>
          <Link to="/services" className="nav-item">
            SERVICES
          </Link>
          <Link to="/our-team" className="nav-item">
            OUR TEAM
          </Link>
          <Link to="/contact" className="nav-item">
            CONTACT
          </Link>
        </div>
        <div className="toggleButton">
          <img
            src={reoder}
            alt=""
            onClick={() => {
              setExpandNavbar(!expandNavbar);
            }}
          />
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
